import { createApi } from '@reduxjs/toolkit/query/react';

import { apiDexBase } from '~constants/api';
import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { DexPreviewParams, DexPreviewResult, DexReadinessParams, DexReadinessResult } from '~dex/types';

export const dexApi = createApi({
  reducerPath: 'dexApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiDexBase }),
  endpoints: (builder) => ({
    getDexPreview: builder.query<DexPreviewResult, DexPreviewParams>({
      query: (params) => ({ url: '/export/preview', method: 'GET', params }),
      transformResponse: (payload) => unwrap<DexPreviewResult>(payload),
    }),
    getDexReadiness: builder.query<DexReadinessResult, DexReadinessParams>({
      query: (params) => ({ url: '/readiness', method: 'GET', params }),
      transformResponse: (payload) => unwrap<DexReadinessResult>(payload),
    }),
  }),
});

export const { useLazyGetDexPreviewQuery, useLazyGetDexReadinessQuery } = dexApi;
